'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class sectionFieldModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	afterSetup(data){
		switch(this.type){
			case 'check':
				this.value = (this.value === '1' || this.value === 1 || this.value === 'true' || this.value === true );
				break;
			case 'inputInt':
				this.value = (!isNaN(this.value)) ? parseInt(this.value) : 0;
				break;
			case 'inputNumber':
				this.value = (!isNaN(this.value)) ? parseFloat(this.value) : 0;
				break;
			case 'date':
				this.value = (!isNaN(this.value) && this.value > 0) ? this.s('$filter')('u2date')(this.value, 'yyyy-MM-dd', '+0000') : '';
				break;
		}
	}
	
	getTitle(){
		return this.title;
	}
	
	getExplain(){
		return this.explain;
	}
	
	getAlert(){
		return this.alert;
	}
	
	getValue(){
		switch(this.type){
			case 'check':
			case 'classifYesNo':
				return this.getClassifValue('value', 'yesno');
			default:
				switch(this.name){
					case 'a1_general_amount':
						return this.s('$filter')('currency')(this.value);
					case 'a1_general_summary':
					case 'a1_general_previous':
					case 'a5_toc_statement':
					case 'a5_toc_goal':
					case 'a5_toc_impacts':
					case 'b1_1_background_objectives':
					case 'b1_2_needs_analysis':
					case 'b1_3_complementarity_with_actions':
					case 'b2_1_concept_methodology':
					case 'b2_2_consortium_management':
					case 'b2_4_quality_assurance_monitoring':
					case 'b2_5_cost_effectiveness_management':
					case 'b2_7_ethics_eu_values':
					case 'b3_1_impact_ambition_fld':
					case 'b3_2_communication_fld':
					case 'b3_3_sustainability_fld':
						return this.s('$filter')('nl2br')(this.value);
					default:
						return this.value;
				}
		}
	}
}